import { render, staticRenderFns } from "./MenuMobileComponent.vue?vue&type=template&id=4cf1ba90"
import script from "./MenuMobileComponent.vue?vue&type=script&lang=js"
export * from "./MenuMobileComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports